import { APIURLLEGALES, APIURLREINGENIERIALEGALES } from "../../const/backend"
import apiClient from "../../utils/apiClient";

class ApiServiceAdapter {
  async fetchJuicios(cuitLetrado, nroSiniestro, caratula, idJuicio) {
    const url = APIURLLEGALES + `/juicios/listar?cuitLetrado=${cuitLetrado || ''}&nroSiniestro=${nroSiniestro || ''}&idJuicio=${idJuicio || ''}&caratula=${caratula || ''}`
    const response = apiClient.get(url)
    const data = await response
    return data;
  }

  async fetchDatosJuicio(idJuicio) {
    const url = APIURLLEGALES + `/juicios/obtenerDatos?idJuicio=${idJuicio || ''}`
    const response = apiClient.get(url)
    const data = await response
    return data;
  }

  async fetchDatosPericiaJuicio(idJuicio) {
    const url = APIURLLEGALES + `/juicios/ObtenerPericias?idJuicio=${idJuicio || ''}`
    const response = apiClient.get(url)
    const data = await response
    return data;
  }

  async fetchDatosSentenciaJuicio(idJuicio) {
    const url = APIURLLEGALES + `/juicios/ObtenerSentencias?idJuicio=${idJuicio || ''}`
    const response = apiClient.get(url)
    const data = await response
    return data;
  }

  async fetchDatosCartaJuicio(idJuicio) {
    const url = APIURLLEGALES + `/juicios/ObtenerCartas?idJuicio=${idJuicio || ''}`
    const response = apiClient.get(url)
    const data = await response
    return data;
  }

  //REINGENIERIA

  async fetchJuiciosReingenieria(body) {
    const url = APIURLREINGENIERIALEGALES + `/GetJuiciosByLetrado`

    const response = apiClient.post(url, body, { withAuth: true, isJson: true, useReing: true });
    const data = await response

    return data;
  }

  async fetchJuiciosByIdReingenieria(body) {
    const url = APIURLREINGENIERIALEGALES + `/GetDatosJuicio`

    const response = apiClient.post(url, body, { withAuth: true, isJson: true, useReing: true });
    const data = await response

    return data;
  }

  async fetchInstruccionesJuiciosByIdReingenieria(nroJuicio) {
    const url = APIURLREINGENIERIALEGALES + `/GetJuicioInstruccionesByJuicio?nroJuicio=${nroJuicio || ''}`

    const response = apiClient.get(url, {useReing: true});
    const data = await response

    return data;
  }  

}

export default ApiServiceAdapter;